const nzStates = [
  { value: 'NTL', label: 'Northland' },
  { value: 'AUK', label: 'Auckland' },
  { value: 'WKO', label: 'Waikato' },
  { value: 'BOP', label: 'Bay of Plenty' },
  { value: 'GIS', label: 'Gisborne' },
  { value: 'HKB', label: "Hawke's Bay" },
  { value: 'TKI', label: 'Taranaki' },
  { value: 'MWT', label: 'Manawatū-Whanganui' },
  { value: 'WGN', label: 'Wellington' },
  { value: 'TAS', label: 'Tasman' },
  { value: 'NSN', label: 'Nelson' },
  { value: 'MBH', label: 'Marlborough' },
  { value: 'WTC', label: 'West Coast' },
  { value: 'CAN', label: 'Canterbury' },
  { value: 'OTA', label: 'Otago' },
  { value: 'STL', label: 'Southland' },
];

export default nzStates;
